import { ReactElement } from "react";

interface DropdownLoaderProps {
  menu: ReactElement;
}

export function DropdownLoader({ menu }: DropdownLoaderProps) {
  return menu;
}
